import { teams } from "../constants";

export const getShortPosition = (position) => {
  const posMap = {
    Goalkeeper: "ГК",
    Defender: "ЗАХ",
    Midfielder: "ПІВ",
    Attacker: "HАП",
  };

  return posMap[position] || "";
};

export const getPosition = (position) => {
  const posMap = {
    Goalkeeper: "ГК",
    Defender: "ЗАХ",
    Midfielder: "ПІВ",
    Attacker: "НАП",
  };
  return posMap[position] || "Усі";
};

export const getPlayerById = (players = [], playerId) => {
  return players.find((player) => player.id === playerId) || {};
};

export const getPlayerLastName = (player) => {
  return player.LastName ?? player?.name;
};

export const getPlayerShortTeam = (player) => {
  return teams[player?.teamId]?.shortName;
};

export const isPlayerExist = (playerId) => {
  return playerId !== null;
};
